<template>
	<div class="dashboard">
		<!--
		<md-card class="md-primary" v-if="notice">
			<md-card-content>
				A Pulmoment használatával elfogadja az adatvédelmni nyilatkozatunkba foglalt feltételeket. A nyilatkozat megtekintéséhez <a style="color: inherit; text-decoration: underline;" target="_blank" href="../static/legal.pdf">kattintson ide.</a>
				<md-icon v-on:click.native="notice = false" style="cursor:pointer; float:right;">cancel</md-icon>
			</md-card-content>
		</md-card>
		-->
		
		<md-card>
			<md-card-content class="row">
				<div class="col-md-6">
					<h3>{{$t("admin.current")}}</h3>
					<span>Új funkció a rendszerben: napi bontás a páciensek adatlapján.</br>{{$t("admin.consultinghours")}}</span>
				</div>
				<div class="col-md-6">
					<h3>{{$t("admin.nextoverall")}}</h3>
					<span v-if="globalInfo.hasNextConsulting">
						{{globalInfo.nextConsultingDate}} (páciensek adatai alapján)
					</span>
					<span v-else>
						{{$t("admin.novisit")}}
					</span>
				</div>
			</md-card-content>
		</md-card>

		<md-card>
			<md-card-header>
				<div class="md-title">{{$t("admin.totalizedsymptoms")}}</div>
				<div class="md-subhead">{{$t("admin.allpatients")}}</div>
			</md-card-header>

			<md-card-content>
				<line-chart :values="globalSymptoms"></line-chart>
			</md-card-content>
		</md-card>

		<md-card>
			<md-card-header>
				<div class="md-title">{{$t("admin.filledinspector")}}</div>
				<div class="md-subhead">{{$t("admin.allpatients")}}</div>
			</md-card-header>

			<md-card-content>
				<md-progress :md-progress="controlProgress()" class="md-accent"></md-progress>
				<p v-if="globalInfo.filledControl > 0">{{globalInfo.patientCount}} páciensből {{globalInfo.filledControl}} töltötte ki az állapotfelmérőt</p>
				<p v-else>{{$t("admin.noinspector")}}</p>
			</md-card-content>

			<md-card-actions>
				<!--<md-button class="md-primary" v-on:click="notifyPatients()">Figyelmeztetés küldése</md-button>-->
			</md-card-actions>
		</md-card>

		<md-table-card>
			<md-toolbar>
				<h1 class="md-title">{{$t("admin.newpatients")}}</h1>
			</md-toolbar>
			<md-table>
				<md-table-header>
					<md-table-row>
						<md-table-head>{{$t("name")}}</md-table-head>
						<md-table-head>{{$t("email")}}</md-table-head>
						<md-table-head>{{$t("admin.numberofsymptoms")}}</md-table-head>
						<md-table-head>{{$t("admin.data")}}</md-table-head>
					</md-table-row>
				</md-table-header>

				<md-table-body>
					<md-table-row v-for="(patient, index) in newPatients" :key="index" :md-item="patient">
						<md-table-cell :key="'name'" :md-numeric="false">{{patient.name ? patient.name : "Nincs név megadva"}}</md-table-cell>
						<md-table-cell :key="'email'" :md-numeric="false">{{patient.email}}</md-table-cell>
						<md-table-cell>{{patient.symptomCount}}</md-table-cell> <!-- :key="patient.symptoms" :md-numeric="true" -->
						<md-table-cell><md-button class="md-primary" v-on:click.native="showPatient(patient)">Adatok</md-button></md-table-cell>
					</md-table-row>
				</md-table-body>
			</md-table>
		</md-table-card>

		<md-card>
			<md-card-header>
				<div class="md-title">Levegő minőség jelentések</div>
			</md-card-header>
			<md-card-content>
				Pollen:
				<a class="md-padding" href="http://oki.antsz.hu/files/jelentesek/aktualis.pdf" target="_blank">ANTSZ</a>
				<a class="md-padding" href="http://www.met.hu/idojaras/humanmeteorologia/pollenjelentes/" target="_blank">MET</a>
				<a class="md-padding" href="https://www.idokep.hu/pollen" target="_blank">Időkép pollen</a>
				Légszennyezettség:
				<a class="md-padding" href="https://www.idokep.hu/szmog" target="_blank">Időkép szmog</a>
				<a class="md-padding" href="http://www.legszennyezes.hu" target="_blank">Légszennyezés.hu</a>
			</md-card-content>
		</md-card>
	</div>
</template>

<script>
	import Api from '../../../generated'
	import LineChart from '../Graphics/LineChart'
	import moment from 'moment'
	import _ from 'lodash'

	export default {
		components: {
			LineChart
		},
		data(){
			return {
				notice: true,
				globalSymptoms: [],
				newPatients: [],
				globalInfo: {
					hasNextConsulting: false
				}
			}
		},
		methods:{
			notifyPatients(){
				this.$bus.$emit('showToast','Figyelmeztetés elküldve')
			},
			showPatient(patient){
				this.$router.push('/admin/patient/' + patient._id);
			},
			controlProgress(){
				if(this.globalInfo.patientCount > 0 && this.globalInfo.filledControl > 0){
					return Math.round((this.globalInfo.filledControl / this.globalInfo.patientCount) * 100);
				}else{
					return 0;
				}
			}
		},
		mounted(){
			this.$bus.$emit('showLoading', true);
			// Load global symptom graph
			Api.ApiClient.instance.getGlobalSymptoms((error, data, response) => {
				if (error) {
					console.error(error);
				} else {
					var symptoms = _.mapValues(_.groupBy(data["data"]["symptoms"],"updatedAt"),"length");
					console.log(JSON.stringify(data));
					var graphData = {
						weeks:[],
						data:[{
							name: "Tünet",
							values: []
						}]
					};
					for(var i = 0; i < 30; i++){
						let day = moment().subtract(i, 'days');
						
						var matches = 0;
						for(let symptomDay in symptoms){
							if(day.isSame(symptomDay, "day")){
								matches++;
							}
						}
						
						graphData.weeks[i] = day.toDate();
						graphData.data[0].values[i] = matches;
					}

					console.log(graphData);
					this.globalSymptoms = graphData;
				}
			});

			Api.ApiClient.instance.getPatientList({
				order : 'registrationDate',
				asc : false,
				skip : 0,
				limit : 5,
				emailPrefix : ""
			}, (error, data, response) => {
				if (error) {
					console.error(error);
				} else {
					this.newPatients = data;
				}
			});

			Api.ApiClient.instance.getGlobalInfo((error, data, response) => {
				if (error) {
					console.error(error);
				} else {
					this.globalInfo = data.data;
					if(this.globalInfo.nextConsultingDate){
						this.globalInfo.nextConsultingDate = moment(this.globalInfo.nextConsultingDate).format('YYYY.MM.DD.');
					}
				}
				this.$bus.$emit('showLoading', false);
			});
		}
	}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Dashboard.vue?a9cce64c